module.exports = __webpack_public_path__ + "static/management-dad623966f1267cf361dc35f58a40c7a.jpg";